import { map } from 'lodash';

import { useGetClassAttendanceQuery } from '@/api/generated';
import { markAttendance } from '@/modules';
import { isAttendanceMarkingEnabled } from '@/utils';

export const useGetClassAttendance = (classData, { cursor, pageSize } = {}) => {
    const classroomId = classData?.classroom?.classroomId;
    const providerArn = classData?.classroom?.providerArn;
    const learningActivityID = classData?.classroom?.learningActivityID;

    const { data, isLoading, refetch, error } = useGetClassAttendanceQuery(
        {
            input: {
                classroomId: classroomId ?? '',
                learningActivityID: learningActivityID ?? '',
                providerArn: providerArn ?? '',
                ...(cursor && { cursor }),
                ...(pageSize && { pageSize }),
            },
        },
        {
            enabled: !!(classroomId && learningActivityID && providerArn),
        },
    );

    return {
        data: data?.getClassAttendance.learningActivityAttendanceRecords,
        pageInfo: data?.getClassAttendance.pageInfo,
        isLoading,
        error,
        refetch,
    };
};

export const useMarkClassAttendance = (classData) => {
    const classroomId = classData?.classroom?.classroomId;
    const providerArn = classData?.classroom?.providerArn;
    const learningActivityID = classData?.classroom?.learningActivityID;
    return async (markAttendanceInputs, onCompleteHandler, onErrorHandler) => {
        return Promise.all(
            map(markAttendanceInputs, async (markAttendanceInput) => {
                if (!classroomId || !providerArn || !learningActivityID) {
                    throw new Error('Attempted to mark attendance for unsupported classroom');
                }
                return await markAttendance({
                    classroomId,
                    providerArn,
                    learningActivityID,
                    ...markAttendanceInput,
                });
            }),
        )
            .then(onCompleteHandler)
            .catch(onErrorHandler);
    };
};

export const isAttendanceListingEnabled = ({ lms_type } = {}) => {
    return isAttendanceMarkingEnabled(lms_type);
};
